// extracted by mini-css-extract-plugin
export default {"trashIcon":"style_trashIcon__cQT22"};